module.exports = __WEBPACK_EXTERNAL_MODULE_4__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"}
 ** module id = 4
 ** module chunks = 0
 **/